module.exports = __webpack_public_path__ + "files/e80b71e0ed7a4023834749b415e959f2.png";